import React from 'react'
import styled from 'styled-components'
import ParseContent from 'components/shared/ParseContent'

const StyledFases = styled.section`
  position: relative;
  z-index: 1;
  padding-top: 100px;
  padding-bottom: 100px;

  @media screen and (max-width: 991px) {
    padding-top: 60px;
    padding-bottom: 60px;
  }
`

const StyledContainer = styled.div`
  height: 100%;

  @media screen and (max-width: 991px) {
    height: unset;
    position: relative;
  }
`

const HeaderBlock = styled.div`
  max-width: 50%;

  @media screen and (max-width: 991px) {
    max-width: 100%;
  }

  & h2 {
    font-weight: ${(props) => props.theme.font.weight.xl};

    @media screen and (min-width: 992px) {
      font-size: ${(props) => props.theme.font.size.xl};
    }

    @media screen and (max-width: 991px) {
      font-size: ${(props) => props.theme.font.size.l};
    }
  }
`
const ItemsBlock = styled.div`
  background: ${(props) => props.theme.color.gradient.main};
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  padding: 40px;
  margin: 0 -40px;
  border-radius: 20px;

  @media screen and (max-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    padding: 24px;
    margin: 0 -24px;
    border-radius: 16px;
  }

  @media screen and (max-width: 575px) {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 10px;
    margin: 0 -10px;
    border-radius: 12px;
  }
`
const FaseItem = styled.div`
  background: ${(props) => props.theme.color.face.light};
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);

  @media screen and (max-width: 991px) {
    border-radius: 16px;
    padding: 20px;
  }

  @media screen and (max-width: 575px) {
    border-radius: 12px;
    padding: 16px;
  }

  & h3 {
    font-weight: ${(props) => props.theme.font.weight.xl};

    @media screen and (min-width: 992px) {
      font-size: ${(props) => props.theme.font.size.xm};
    }

    @media screen and (max-width: 991px) {
      font-size: ${(props) => props.theme.font.size.mx};
    }
  }
`
const Line = styled.div`
  background: ${(props) => props.theme.color.gradient.main};
  height: 4px;
  width: 40%;
  border-radius: 20px;
`

const Fases = ({ className = '', content, id = 'fases' }) => {
  if (!content) return null
  return (
    <StyledFases id={id} className={`${className}`}>
      <StyledContainer className="container">
        <HeaderBlock className="pb-1">
          <h2>{content?.title}</h2>
          <ParseContent
            className="mt-1"
            content={content?.description}
            compactLineHeight
          />
        </HeaderBlock>
        <ItemsBlock className="mt-3 mt-lg-4">
          {content?.items?.map((fase, index) => (
            <FaseItem key={index}>
              <h3>Fase {index + 1}</h3>
              <Line className="mt-1" />
              <ParseContent className="mt-3" content={fase?.description} compactLineHeight />
            </FaseItem>
          ))}
        </ItemsBlock>
      </StyledContainer>
    </StyledFases>
  )
}

export default Fases
